import React from 'react';
import Message from './Message';
import ChatInfoScreen from './ChatInfoScreen';

const MessageList = ({
  messages,
  projectID,
  hasEditPermission,
  selectedExcerptId,
  onExcerptSelected,
  streamConfig,
  streamData
}) => {
  if (!messages || messages.length === 0) {
    return <ChatInfoScreen/>
  }

  return messages.map((message, index) => {
    const content = streamConfig.message_id === message.id ? streamData : message.content;
    
    return <Message
      key={index}
      message={message}
      content={content}
      selectedExcerptID={selectedExcerptId}
      projectID={projectID}
      hasEditPermission={hasEditPermission}
      onExcerptSelected={onExcerptSelected}
      postfix={message.postfix}
    />
  })
};

export default MessageList;
